import { Injectable } from '@angular/core';
import { MenuStage, NavigationLinkBase } from '@ebeihilfe/core';

@Injectable()
export class CustomNavLink extends NavigationLinkBase {
  public allowedStages = MenuStage.SIGNED_IN;
  public mdIcon = 'link';

  public constructor() {
    super('CUSTOM_NAVLINK', 'label.custom', '');
  }
}
